export default [
    { id: 1, label: "Дизайн-студия" },
    { id: 2, label: "Дизайн бренда" },
    { id: 3, label: "Дизайн-сообщество" }
]
